class Tool {
  constructor() {
    this.name = "Tool Display Name";
    this.flag = false;
    this.prevX = 0;
    this.currX = 0;
    this.prevY = 0;
    this.currY = 0;
    this.downScale = 2;
  }

  setLayer() {}

  setPreviewRect() {}

  initDrawing() {}

  updateDrawing() {}

  mouse() {}

  drawCustomCursor() {}

  renderConfiguration() {}

  exit() {}
}

export default Tool;
